

<div class="card">
  <div class="card-content">

    <div class="stats-cards-row">
      <div class="stats-card stats-card--total">
        <div class="stats-card-main">
          <span class="stats-card-value">{{ totalProjectsCount }}</span>
          <span class="stats-card-label">Total Projects</span>
          <span class="stats-card-sublabel">Active projects</span>
        </div>
        <div class="stats-card-icon"><i class="pi pi-folder-open"></i></div>
      </div>
      <div class="stats-card stats-card--success">
        <div class="stats-card-main">
          <span class="stats-card-value">{{ greenCount }}</span>
          <span class="stats-card-label">On Track</span>
          <span class="stats-card-sublabel">Status green</span>
        </div>
        <div class="stats-card-icon"><i class="pi pi-check-circle"></i></div>
      </div>
      <div class="stats-card stats-card--warning">
        <div class="stats-card-main">
          <span class="stats-card-value">{{ amberRedCount }}</span>
          <span class="stats-card-label">Needs Attention</span>
          <span class="stats-card-sublabel">Amber / Red status</span>
        </div>
        <div class="stats-card-icon"><i class="pi pi-exclamation-circle"></i></div>
      </div>
      <div class="stats-card stats-card--total">
        <div class="stats-card-main">
          <span class="stats-card-value">{{ showingCount }}</span>
          <span class="stats-card-label">Showing</span>
          <span class="stats-card-sublabel">After filters</span>
        </div>
        <div class="stats-card-icon"><i class="pi pi-list"></i></div>
      </div>
    </div>

    <div class="filter-bar filter-bar-collapsible mb-4" [class.filter-bar-visible]="pageHeaderService.currentFiltersVisible">
      <div class="filter-bar-filters">
        <div class="filter-field">
          <label for="statusFilter" class="filter-label">Status</label>
          <p-select id="statusFilter" [(ngModel)]="selectedStatusFilter" (ngModelChange)="onStatusFilterChange()"
            [options]="statusFilterOptions" optionLabel="label" optionValue="value" placeholder="All"
            [showClear]="true" [filter]="true" filterPlaceholder="Search status..."
            panelStyleClass="filter-dropdown-panel" appendTo="body" />
        </div>
        <div class="filter-field">
          <label for="progressFilter" class="filter-label">Progress</label>
          <p-select id="progressFilter" [(ngModel)]="selectedProgressFilter" (ngModelChange)="onProgressFilterChange()"
            [options]="progressFilterOptions" optionLabel="label" optionValue="value" placeholder="All"
            [showClear]="true" [filter]="true" filterPlaceholder="Search progress..."
            panelStyleClass="filter-dropdown-panel" appendTo="body" />
        </div>
        <div class="filter-field">
          <label for="accountManagerFilter" class="filter-label">Account Manager</label>
          <p-select id="accountManagerFilter" [(ngModel)]="selectedAccountManagerFilter"
            (ngModelChange)="onAccountManagerFilterChange()" [options]="accountManagerFilterOptions"
            optionLabel="label" optionValue="value" placeholder="All"
            [showClear]="true" [filter]="true" filterPlaceholder="Search account manager..."
            panelStyleClass="filter-dropdown-panel" appendTo="body" />
        </div>
        <div class="filter-field">
          <label for="managerFilter" class="filter-label">Project Manager</label>
          <p-select id="managerFilter" [(ngModel)]="selectedManagerFilter" (ngModelChange)="onManagerFilterChange()"
            [options]="managerFilterOptions" optionLabel="label" optionValue="value" placeholder="All"
            [showClear]="true" [filter]="true" filterPlaceholder="Search project manager..."
            panelStyleClass="filter-dropdown-panel" appendTo="body" />
        </div>
        <div class="filter-field">
          <label for="serviceGroupFilterPlan" class="filter-label">Service Group</label>
          <p-select id="serviceGroupFilterPlan" [(ngModel)]="selectedServiceGroupFilter"
            (ngModelChange)="onServiceGroupFilterChange()" [options]="serviceGroupFilterOptions"
            optionLabel="label" optionValue="value" placeholder="All"
            [showClear]="true" [filter]="true" filterPlaceholder="Search service group..."
            panelStyleClass="filter-dropdown-panel" appendTo="body" />
        </div>
        <div class="filter-field">
          <label for="clientFilterPlan" class="filter-label">Client</label>
          <p-select id="clientFilterPlan" [(ngModel)]="selectedClientFilter"
            (ngModelChange)="onClientFilterChange()" [options]="clientFilterOptions"
            optionLabel="label" optionValue="value" placeholder="All"
            [showClear]="true" [filter]="true" filterPlaceholder="Search client..."
            panelStyleClass="filter-dropdown-panel" appendTo="body" />
        </div>
      </div>
      <div class="filter-bar-actions" *ngIf="hasActiveFilters()">
        <button type="button" class="btn-clear-filters" (click)="clearFilters()" title="Clear all filters">
          <i class="pi pi-filter-slash"></i>
        </button>
      </div>
    </div>

  <!-- Projects Table -->
  <div class="list-view-container">
    <p-table
      [scrollable]="true" scrollHeight="flex"
      [value]="filteredProjects"
      [loading]="loading"
      [tableStyle]="{ 'min-width': '100%' }"
      styleClass="p-datatable no-column-lines compact-striped-table resize-handles-visible"
      [resizableColumns]="true"
      columnResizeMode="expand"
      [rowHover]="true"
      [paginator]="true"
      [alwaysShowPaginator]="false"
      [rows]="20"
      [rowsPerPageOptions]="[10, 20, 50, 100]"
      [showCurrentPageReport]="true"
      currentPageReportTemplate="Showing {first} to {last} of {totalRecords} projects">
      
      <ng-template pTemplate="header">
        <tr>
          <!-- Row-expander column: fixed width, deliberately not resizable. -->
          <th style="width: 50px;"></th>
          <th pResizableColumn pSortableColumn="name">
            Project Name
            <p-sortIcon field="name" />
          </th>
          <th pResizableColumn pSortableColumn="clientName">
            Client
            <p-sortIcon field="clientName" />
          </th>
          <th pResizableColumn pSortableColumn="accountManagerName">
            Account Manager
            <p-sortIcon field="accountManagerName" />
          </th>
          <th pResizableColumn pSortableColumn="managerName">
            PM
            <p-sortIcon field="managerName" />
          </th>
          <th pResizableColumn pSortableColumn="status">
            Status
            <p-sortIcon field="status" />
          </th>
          <th pResizableColumn pSortableColumn="progress">
            Progress
            <p-sortIcon field="progress" />
          </th>
          <th pResizableColumn pSortableColumn="startDate">
            Start Date
            <p-sortIcon field="startDate" />
          </th>
          <th pResizableColumn pSortableColumn="endDate">
            End Date
            <p-sortIcon field="endDate" />
          </th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-project>
        <tr>
          <td>
            <p-button
              [icon]="isRowExpanded(project) ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"
              (onClick)="toggleRow(project); $event.stopPropagation()"
              [text]="true"
              severity="secondary"
              size="small"
              [pTooltip]="isRowExpanded(project) ? 'Collapse' : 'Expand'" />
          </td>
          <td class="td-truncate" [pTooltip]="project.name" tooltipPosition="top">
            <strong>{{ project.name }}</strong>
          </td>
          <td class="td-truncate" [pTooltip]="project.clientName || '-'" tooltipPosition="top">{{ project.clientName || '-' }}</td>
          <td class="td-truncate" [pTooltip]="project.accountManagerName || '-'" tooltipPosition="top">{{ project.accountManagerName || '-' }}</td>
          <td class="td-truncate" [pTooltip]="project.managerName || '-'" tooltipPosition="top">{{ project.managerName || '-' }}</td>
          <td>
            <p-tag
              [value]="project.status || 'N/A'"
              [severity]="getStatusSeverity(project.status)" />
          </td>
          <td>
            <p-tag
              [value]="project.progress || 'N/A'"
              [severity]="getProgressSeverity(project.progress)" />
          </td>
          <td>{{ formatDate(project.startDate) }}</td>
          <td>{{ formatDate(project.endDate) }}</td>
        </tr>
        <!-- Manual expansion row -->
        <tr *ngIf="isRowExpanded(project)" class="expansion-row">
          <td colspan="9" class="expansion-cell">
            <div class="payment-tracking-wrapper">
              <app-payment-tracking
                [projectId]="project.id"
                [filterDate]="filterDate"
                [readonly]="isSalesReadonly">
              </app-payment-tracking>
            </div>
            <div class="work-notes-wrapper">
              <app-work-notes
                [projectId]="project.id"
                [readonly]="isSalesReadonly">
              </app-work-notes>
            </div>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr class="table-empty-row">
          <td [attr.colspan]="9" class="table-empty-cell">
            <div class="empty-state">
              <div class="empty-icon"><i class="pi pi-inbox"></i></div>
              <p class="empty-message">No active projects found</p>
              <p class="empty-description">Try changing filters or search text</p>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
  </div>
</div>

